// eslint-disable-next-line
export const getBrowser = (state) => state.get('browser');
